import theme from '../../theme';
export const styles = ()=>({
        checkboxWrapper: {
            display: 'flex',
            height: theme.space[32],
            paddingLeft: theme.space[12],
            cursor: 'pointer'
        }
    });
